import { FaSearch } from "react-icons/fa";
import { LuMountainSnow } from "react-icons/lu";
import { WiDayCloudy } from "react-icons/wi";
import { SiGooglemaps } from "react-icons/si";
import { useState } from "react";

const DestinationSearchBarComponent = ({ handleSearch }) => {
  const [q, setQ] = useState();
  // const [startDate, setStartDate] = useState();
  // const [difficulty, setDifficulty] = useState();
  // const [type, setType] = useState();
  // const [country, setCountry] = useState();

  const handleSearchClicked = () => {
    let search = {};
    if (q !== null && q !== undefined) {
      search["q"] = q;
    }

    // if (startDate !== null && startDate !== undefined) {
    //   search["startDate"] = startDate;
    // }

    // if (difficulty !== null && difficulty !== undefined) {
    //   search["difficulty"] = difficulty;
    // }
    // if (type !== null && type !== undefined) {
    //   search["type"] = type;
    // }

    // if (country !== null && country !== undefined) {
    //   search["country"] = country;
    // }

    return handleSearch(search);
  };

  return (
    <div className="mb-20 shadow-md px-5 sm:px-10 py-5 border-t">
      <div className="py-5 text-2xl sm:text-4xl font-semibold">
        Search country destination...
      </div>

      <div>
        {/* Search Input */}
        <div className="relative w-full my-2">
          <input
            type="text"
            name="q"
            placeholder="Search..."
            className="w-full p-4 pl-14 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-16"
            onChange={(text) => setQ(text?.target?.value)}
          />
          <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
        </div>

        {/* Filters - use flex-wrap and responsive stacking */}
        {/* <div className="flex flex-col lg:flex-row lg:space-x-5 space-y-5 lg:space-y-0 mt-5">
    
          <div className="relative w-full">
            <input
              type="date"
              name="date"
              className="w-full p-4 pl-5 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-16"
              onChange={(date) => setStartDate(date?.target?.value)}
            />
          </div>

    
          <div className="relative w-full">
            <select
              className="w-full p-4 pr-10 pl-12 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-16"
              onChange={(diff) => setDifficulty(diff?.target?.value)}
            >
              <option value={""}>Select Difficulty</option>
              <option value={"1"}>Beginner friendly</option>
              <option value={"2"}>Moderate</option>
              <option value={"3"}>Challenging</option>
              <option value={"4"}>Very Hard</option>
            </select>
            <LuMountainSnow className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
          </div>

  
          <div className="relative w-full">
            <select
              className="w-full p-4 pr-10 pl-12 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-16"
              onChange={(typ) => setType(typ?.target?.value)}
            >
              <option value={""}>Adventure Type</option>
              <option value={"1"}>Day Hike</option>
              <option value={"2"}>Overnight</option>
              <option value={"3"}>Mountaineering</option>
            </select>
            <WiDayCloudy className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
          </div>

       
          <div className="relative w-full">
            <select
              className="w-full p-4 pr-10 pl-12 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-16"
              onChange={(count) => setCountry(count?.target?.value)}
            >
              <option value={""}>Country</option>
              <option value={"KE"}>Kenya</option>
              <option value={"TZ"}>Tanzania</option>
              <option value={"UG"}>Uganda</option>
              <option value={"RW"}>Rwanda</option>
            </select>
            <SiGooglemaps className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
          </div>
        </div> */}

        {/* Search Button */}
        <div className="my-5 w-full">
          <button
            className="bg-color-primary-dark2 w-full py-4 rounded-lg text-color-white font-bold text-lg"
            onClick={handleSearchClicked}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default DestinationSearchBarComponent;
